import {successRedirectPrepare} from "./helpers";

function newRedirectPopup (logoFrom, logoTo, linkTo, params) {
  $('.fixed-progress').addClass('hidden')

  let amountAdditional = ''
  for (let i in params.amountAdditional) {
    amountAdditional += `<p class="squeeze-block__cash">${params.amountAdditional[i].label}: <span id="squeeze-block__cash">${params.amountAdditional[i].value}</span></p>`
  }
  let squeezeStyles = `<style>h1{font-weight:300;margin-bottom:15px;color:#5bb73b}.squeeze-block__title p{font-size:14px;line-height:1.3em}.squeeze-block__title{margin-top:50px}.squeeze-block__title p b{font-weight:700}.squeeze-block__title p+p{margin-top:10px}.squeeze-block__logos{display:flex;justify-content:center;align-items:center;margin:30px 0}.squeeze-block__logos-wrap{max-width:200px;display:flex;align-items:center}.squeeze-block__logos-wrap:nth-of-type(1){justify-content:flex-end;display:flex}.squeeze-block__logos-wrap:nth-of-type(2){justify-content:flex-start}.squeeze-block__logos-crezu{fill:#5bb73b}.squeeze-block__logos-mfo{max-height:50px;max-width:200px}.squeeze-block__logos-arrows{display:flex;margin:35px 50px}@media screen and (max-width:600px){.squeeze-block__logos-arrows{margin:10px 20px}}.squeeze-block__logos-arrows svg{opacity:0;animation:fadeIn 1s infinite}.squeeze-block__logos-arrows svg:nth-of-type(2){animation-delay:.25s}.squeeze-block__logos-arrows svg:nth-of-type(3){animation-delay:.5s}.squeeze-block__logos-arrows svg:nth-of-type(4){animation-delay:.75s}@keyframes fadeIn{0%{opacity:0}20%{opacity:.1}40%{opacity:.75}60%{opacity:.5}80%{opacity:.25}100%{opacity:0}}.squeeze-block__cash span{font-weight:700}.squeeze-block__title p{font-size:16px}.squeeze-block__logos-arrows{display:flex}.squeeze-block__logos-wrap:nth-of-type(1){display:flex}.reserve-redirect-button{font-size:18px;line-height:40px;margin-top:10px;padding: 5px 20px;width: 100%;max-width: 375px;}.reserve-redirect-button:hover{color:#fff}#squeeze-block{text-align:center;max-width:90vw;margin:auto}.squeze_additionalText{margin-top: 20px;text-align: left;padding: 0px 10px;color: #747272;}</style>`
  let popupLayout = `<div id="squeeze-block">
    <div class="container">
      <div class="squeeze-block__title">
        <h1>${params.header}</h1>
        <p>${params.subheader}</p>
      </div>
      <!-- logos -->
      <div class="squeeze-block__logos">
        <div class="squeeze-block__logos-wrap">
          ${logoFrom ? `<img src="${logoFrom}" alt="" class="squeeze-block__logos-crezu">` : ''}
        </div>
        <div class="squeeze-block__logos-arrows">
          <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15.7px" height="27.1px" viewBox="0 0 15.7 27.1" style="enable-background:new 0 0 15.7 27.1;" xml:space="preserve">
          <style type="text/css">
            .starrow{fill:none;stroke:#5BB73B;stroke-width:3;stroke-miterlimit:10;}
          </style>
          <polyline class="starrow" points="1.1,1.1 13.6,13.6 1.1,26.1 "></polyline>
          </svg>
          <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15.7px" height="27.1px" viewBox="0 0 15.7 27.1" style="enable-background:new 0 0 15.7 27.1;" xml:space="preserve">
          <style type="text/css">
            .starrow{fill:none;stroke:#5BB73B;stroke-width:3;stroke-miterlimit:10;}
          </style>
          <polyline class="starrow" points="1.1,1.1 13.6,13.6 1.1,26.1 "></polyline>
          </svg>
          <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15.7px" height="27.1px" viewBox="0 0 15.7 27.1" style="enable-background:new 0 0 15.7 27.1;" xml:space="preserve">
          <style type="text/css">
            .starrow{fill:none;stroke:#5BB73B;stroke-width:3;stroke-miterlimit:10;}
          </style>
          <polyline class="starrow" points="1.1,1.1 13.6,13.6 1.1,26.1 "></polyline>
          </svg>
                    <svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15.7px" height="27.1px" viewBox="0 0 15.7 27.1" style="enable-background:new 0 0 15.7 27.1;" xml:space="preserve">
          <style type="text/css">
            .starrow{fill:none;stroke:#5BB73B;stroke-width:3;stroke-miterlimit:10;}
          </style>
          <polyline class="starrow" points="1.1,1.1 13.6,13.6 1.1,26.1 "></polyline>
          </svg>
        </div>
        <div class="squeeze-block__logos-wrap">
          <img src="${logoTo}" alt="" class="squeeze-block__logos-mfo">
        </div>
      </div>
      <!-- p -->
      <p class="squeeze-block__cash ${params.amount ? '' : 'hidden'}">${params.amountHint}: <span id="squeeze-block__cash">${params.currency}${params.amount}</span></p>
      ${amountAdditional}
      <p class="squeeze-block__cash ${params.period ? '' : 'hidden'}">${params.periodHint}: <span>${params.period}</span></p>
      <a class="ui-button reserve-redirect-button" href="${linkTo}">${params.button}</a>
      ${params.additionalText ? `<p class="squeze_additionalText">${params.additionalText}</p>` : ''}
    </div>
    </div>`
  $('.box-wrapper').addClass('hidden');
  $('body').append(squeezeStyles).append(popupLayout)
  let finalRedirect = function () {
    if (params.redirector) {
      params.redirector(linkTo)
    } else {
      successRedirectPrepare()
      window.location.href = linkTo
    }
  }
  let timeoutRedirect = setTimeout(function () {
    finalRedirect()
  }, params.timeout)
  $('.reserve-redirect-button').on('click', function () {
    finalRedirect()
    clearTimeout(timeoutRedirect)
  })
}

export {
  newRedirectPopup
}
